import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { fullAudiences } from 'inside-out/managers/audienceManager';
import { idToLink } from 'inside-out/managers/navManager';

import { Cards } from 'inside-out/components/shared/cards';
import { FeaturedCard } from 'inside-out/components/shared/cards/featuredCard';
import { ResourceCard } from 'inside-out/components/shared/cards/resourceCard';
import { CommonPageHeader } from 'inside-out/components/blog-and-podcast/commonPageHeader';

import {
	innerWrapperStyle,
	featuredCardSectionStyle,
	subTitleStyle,
} from 'inside-out/page-styles/blog-and-podcast';

import { cardSection } from 'inside-out/global-styles';

const BlogTilePropType = PropTypes.shape({
	id: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	date: PropTypes.string.isRequired,
	extract: PropTypes.string.isRequired,
	fields: PropTypes.shape({
		thumbnail_image: PropTypes.shape({
			childImageSharp: PropTypes.shape({
				resize: PropTypes.shape({
					src: PropTypes.string.isRequired,
				}).isRequired,
			}).isRequired,
		}).isRequired,
	}).isRequired,
});

export default class BlogAndPodcastPage extends React.PureComponent {
	static propTypes = {
		data: PropTypes.shape({
			page: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							blue_heading: PropTypes.string.isRequired,
							featured_blog: BlogTilePropType,
						}),
					})
				),
			}),

			recentBlogPosts: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: BlogTilePropType.isRequired,
					})
				).isRequired,
			}).isRequired,
		}).isRequired,
	};

	render() {
		const { recentBlogPosts } = this.props.data;
		const pageSettings = this.props.data.page.edges[0].node;
		let featuredCard;
		let otherBlogPosts;

		if (pageSettings.featured_blog) {
			featuredCard = pageSettings.featured_blog;
			otherBlogPosts = recentBlogPosts.edges
				.filter(({ node }) => node.id !== featuredCard.id)
				.slice(0, 4);
		} else {
			featuredCard = recentBlogPosts.edges[0].node;
			otherBlogPosts = recentBlogPosts.edges.slice(1, 5);
		}

		return (
			<React.Fragment>
				<Helmet title={pageSettings.blue_heading}>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content={pageSettings.blue_heading}/>
          <meta name="description" content="InsideOut Blog &amp; Podcast"/>
          <meta property="og:description" content="InsideOut Blog &amp; Podcast"/>
        </Helmet>

				<CommonPageHeader activeItem="blog-and-podcast" />

				<div className={innerWrapperStyle}>
					<div>
						<section className={featuredCardSectionStyle}>
							<header>
								<h1 className={subTitleStyle}>{pageSettings.blue_heading}</h1>
							</header>

							<FeaturedCard
								audiences={fullAudiences(featuredCard.audiences)}
								to={idToLink(featuredCard.id)}
								title={featuredCard.title}
								date={featuredCard.date}
								background={
									featuredCard.fields &&
									featuredCard.fields.thumbnail_image &&
									featuredCard.fields.thumbnail_image.childImageSharp.resize.src
								}
							/>
							{otherBlogPosts && (
								<div className={cardSection(14)}>
									<Cards columns={4}>
										{otherBlogPosts.map(({ node }, index) => (
											<ResourceCard
												key={index}
												background={
													node.fields && node.fields.thumbnail_image.childImageSharp.resize.src
												}
												to={idToLink(node.id)}
												audiences={fullAudiences(node.audiences)}
												title={node.title}
												type='blog'
												body={node.extract}
												date={node.date}
											/>
										))}
									</Cards>
								</div>
							)}
						</section>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export const query = graphql`
	query BlogAndPodcastPageQuery {
		page: allContentJson(filter: { id: { regex: "/content\\/blog-and-podcast-page\\.json/" } }) {
			edges {
				node {
					blue_heading
					featured_blog {
						...blog
					}
				}
			}
		}

		recentBlogPosts: allBlogJson(sort: { order: DESC, fields: [date] }, limit: 5) {
			...blogs
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/blog-and-podcast/index.js